import moment from 'moment'
import { getComp } from '../../../utils/utils/DI'
import { addressKeys, subscriberInfo } from '../store/store.conts'
import { HistoryItemType } from '../types/store.types'

export const getNormalizedHistoryData = (
  data: any,
  getConflictName: (id: number) => string,
  isCustomer?: boolean,
  isEquipmentSettings?: boolean,
): HistoryItemType[] => {
  const authorsStore = getComp('AuthorsStore')
  const statusesStore = getComp('StatusesStore')
  const dealersStore = getComp('DealersStore')

  const normalizedData: HistoryItemType[] = data.map((i: any) => {
    const item = { ...i }

    item.time = {
      value: moment(item.time).format('DD.MM.YYYY, HH:mm') /*+ '(UTC)'*/,
      label: 'Дата и время:',
    }

    if (item.sourceType === 2) {
      item.status = {
        value: statusesStore.getServiceOrderStatusName(item.sourceValue.Status),
        icon: statusesStore.getServiceOrderStatusImage(item.sourceValue.Status),
        label: '',
      }

      item.request = {
        value: `№ ${item.sourceValue.Id}`,
        label: 'Заявка на обслуживание',
      }
    } else if (item.sourceType === 1) {
      item.status = {
        value: statusesStore.getStatusName(item.sourceValue.Status),
        icon: statusesStore.getStatusImage(item.sourceValue.Status),
        label: '',
      }

      item.request = {
        value: `№ ${item.sourceValue.Id}`,
        label: 'Заявка на установку',
      }
    }

    if (!isCustomer) {
      item.status = isEquipmentSettings
        ? {
            value: statusesStore.getAgreementStatus(item.status)?.name,
            icon: statusesStore.getAgreementStatus(item.status)?.imageSrc,
            label: 'Статус:',
          }
        : {
            value: statusesStore.getStatusName(item.status),
            icon: statusesStore.getStatusImage(item.status),
            label: 'Статус:',
          }
    }

    if (typeof item.author === 'string') {
      item.author = {
        value: authorsStore.getName(item.author)?.name
          ? authorsStore.getName(item.author).name
          : item.author,
        label: 'Автор:',
      }
    }

    if (item.info.length) {
      item.info.forEach((element: any) => {
        if (element.type === 1) {
          item.dealer = {
            value: dealersStore.getDealer(element.value)?.displayName,
            label: 'Дилер:',
          }
        }

        if (element.type === 2) {
          item.photos = {
            value: element.value + ' фото добавлено',
            label: 'Фото:',
          }
        }
        if (element.type === 3) {
          item.equipmentId = {
            value: isCustomer ? `→ ${element.value}` : element.value,
            label: 'Id оборудования:',
          }
        }
        if (element.type === 25) {
          item.agreement = {
            value: `→ ${element.value}`,
            label: '№ договора:',
          }
        }
        if (element.type === 46 && element.value) {
          item.duplicateAddress = {
            value: true,
            label: 'Подтверждена повторная установка по адресу',
          }
        }

        if (element.type === 4) {
          item.createDate = {
            value: moment(element.value).format('DD.MM.YYYY, HH:mm'), // + '(UTC)',
            label: 'Дата обращения:',
          }
        }
        if (element.type === 5) {
          item.installationDate = {
            value: moment(element.value).format('DD.MM.YYYY, HH:mm'), //+ '(UTC)',
            label: 'Дата установки:',
          }
        }
        if (element.type === 26) {
          item.customerInstallationDate = {
            value: moment(element.value).format('DD.MM.YYYY, HH:mm'), //+ '(UTC)',
            label: 'Дата заключения договора:',
          }
        }
        if (element.type === 6) {
          if (element.value) {
            item.reportNumber = {
              value: element.value.isAvailable
                ? element.value.id
                : `${element.value.id} (отчёт расформирован)`,
              isAvailable: element.value.isAvailable,
              label: 'Номер отчета:',
            }
          }
        }
        if (element.type === 7) {
          item.financialSource = {
            value: element.value,
            label: 'Тип оплаты:',
          }
        }
        // Проблемная зона
        if (element.type === 40) {
          item.financialSource = {
            value: element.value
              ? 'Отмечена как проблемная зона'
              : 'Исключена из проблемной зоны',
            label: '',
          }
        }
        if (element.type === 8) {
          item.serialNumber = {
            value: element.value,
            label: 'Серийный номер:',
          }
        }
        if (element.type === 9) {
          const keys = Object.keys(subscriberInfo)

          Object.keys(element.value).forEach((key) => {
            if (keys.includes(key)) {
              let value = element.value[key]

              // если это дата установки, форматируем ее
              if (key === 'Installed' || key === 'installed') {
                value = moment(value).format('DD.MM.YYYY')
              }

              // обработка льготных категорий
              if (key === 'Categories' && Array.isArray(value.categories)) {
                value = value.categories
              }

              item[key] = { value: value, label: subscriberInfo[key] }
            }
          })
        }
        if (element.type === 10) {
          item.reasonId = {
            value: element.value,
            label: 'Причина установки: ',
          }
        }

        if (element.type === 11) {
          let resTerritoryFrom: (string | null)[] = []
          let resTerritoryTo: (string | null)[] = []
          let resultString = ''
          element.value.map((el: any) => {
            if (addressKeys.includes(el.property)) {
              if (el.from) {
                resTerritoryFrom.push(el?.from)
              }
              if (el.to || isCustomer) {
                resTerritoryTo.push(el?.to ?? '-')
              }
            } else {
              item[el.property] = {
                value: el.from ? `${el.from} → ${el.to || '-'}` : el.to || '-',
                label: subscriberInfo[el.property],
              }
            }
          })
          resultString = `${resTerritoryFrom.join(
            ', ',
          )} → ${resTerritoryTo.join(', ')}`

          if (resTerritoryFrom.length) {
            item.Territory = { value: resultString, label: 'Адрес: ' }
          } else if (isCustomer && resTerritoryTo.length) {
            item.Territory = {
              value: resTerritoryTo.join(', '),
              label: 'Адрес: ',
            }
          }
        }

        if (element.type === 24) {
          item.isVerified = {
            value: element.value,
            label: 'Верифицирован: ',
          }
        }

        if (element.type === 28) {
          item.editReason = {
            value: element.value,
            label: 'Основание изменения договора: ',
          }
        }

        if (element.type === 41) {
          item.editReason = {
            value: element.value,
            label: 'Основание изменения приёмника:',
          }
        }

        if (element.type === 36) {
          item.agreement = {
            value: element.value,
            label: 'Договор откреплён:',
          }
        }
        if (element.type === 37) {
          item.agreement = {
            value: element.value,
            label: 'Договор закреплён: ',
          }
        }
        if (element.type === 38) {
          item.editReason = {
            value: element.value,
            label: 'Перепривязка договора: ',
          }
        }
        if (element.type === 39) {
          item.editReason = {
            value: element.value,
            label: 'Перепривязка договора: ',
          }
        }

        if (element.type === 45) {
          if (!item.conflicts) {
            item.conflicts = []
          }

          item.conflicts.push({
            value: element.value.value ? 'Поднят' : 'Снят',
            label: `Конфликт "${getConflictName(element.value.issueId)}": `,
          })
        }
      })
    }

    delete item.info
    return item
  })

  return normalizedData
}
